import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { palette, FiltersPopover, FilterIcon } from '@dev/ee-components';
import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';

import dayjs from '@/services/tools/dayjs';
import { ContactGetGrowthStart, ContactsOverviewStartLoading } from '@/store/contacts/actions';
import useDateDropdownOptions from '@/services/hooks/useDateDropdownOptions';
import { DateDropdownOptions } from '@/services/dictionaries/DateRangeValues';
import { useDateDropdownValue } from '@/services/hooks/useDateDropdownValue';

import { DateRangeSelectInterface } from '../ContactOverview';

export const MobileDateFilter = (props: DateRangeSelectInterface) => {
    const { t } = useTranslation();
    const {  setContactsGrowthFrom, setContactsGrowthTo, contactsGrowthFrom, contactsGrowthTo, isUrlUpdateDisabled} = props;
    const dispatch = useDispatch();
    const dateOptions = useDateDropdownOptions();
    const dateRangeValue = useDateDropdownValue(true);
    const location = useLocation();
    const query = parse(location.search);
    let From = query?.from?.toString() ?? contactsGrowthFrom;
    let To = query?.to?.toString() ?? contactsGrowthTo;

    const filterApply = (filtersObj, momentFrom, momentTo): void => {
        let dateValue = filtersObj[0];
        let datesDiff;

        switch (dateValue) {
            case DateDropdownOptions.Calendar:
                From = dayjs(momentFrom).startOf('day').utc().format();
                To = dayjs(momentTo).utc().format();
                datesDiff = dayjs(momentTo).utc().diff(From, 'day').toString();
                dayjs().isSame(To, 'day') && (dateValue = datesDiff);
                break;
            default:
                From = dayjs().subtract(dateValue, 'day').startOf('day').utc().format();
                To = dayjs().format();
                break;
        }

        setContactsGrowthFrom(From);
        setContactsGrowthTo(To);
        dispatch(ContactGetGrowthStart(From, To, isUrlUpdateDisabled));
        dispatch(ContactsOverviewStartLoading({ From, To }));
    };

    const filterTab = [
        {
            label: t('daterange'),
            defaultValue: dateRangeValue as string,
            options: dateOptions.slice(1),
            type: 'date' as const,
            startDate: From?.toString(),
            endDate: To?.toString(),
        },
    ];
    return (
        <FiltersPopover
            onApply={(obj, momentFrom, momentTo): void => {
                filterApply(obj, momentFrom, momentTo);
            }}
            tabs={filterTab}
            title={t('filters')}
            translations={{
                apply: t('apply'),
                close: t('close'),
            }}
        >
            <FilterIcon color={palette.gray[6]} width={20} height={20} />
        </FiltersPopover>
    );
};
